import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import HeadlineStack from '@mlb/react-patterns/v4/components/HeadlineStack/headlineStack';
import Skeleton from '@mlb/react-patterns/v4/components/Skeleton/skeleton';
import useTracking from '@gameday/utils/hooks/useTracking';

import {
    TitleWrapper,
    MoreCoverageWrapper
} from './morecoverage.style';

const fragment = ({ children }) => <>{children}</>;
const MoreCoverage = ({
    articleList = [],
    isLoading = false,
    deviceInteraction = {},
    contentContainer
}) => {
    const title = useTranslator('label_more_coverage', 'More Coverage');
    const Tracking = useTracking();

    const handleArticlePage = useCallback((e) => {
        const anchorEl = e?.currentTarget;
        const cfg = {
            componentName: ['More Coverage'],
            text: e?.currentTarget.innerText || '',
            activity: ' Link Click'
        };
        Tracking.track.track_click(cfg);

        if (anchorEl && deviceInteraction) {
            const contentId = anchorEl.getAttribute('data-contentid');
            const link = anchorEl.getAttribute('href');
            const headline = anchorEl.getAttribute('data-headline');
            if (deviceInteraction.openArticle({ contentId, title: headline })) {
                e.preventDefault();
                return false;
            } else if (deviceInteraction.webview({ url: link, external: false })) {
                e.preventDefault();
                return false;
            }
        }
    }, [deviceInteraction]);

    const handlers = useMemo(() => ({
        onClick: handleArticlePage
    }), [handleArticlePage]);

    const HeadlineStackContainer = contentContainer || fragment;
    return (
        articleList && articleList?.length > 0
            ? <MoreCoverageWrapper>
                <TitleWrapper>{isLoading ? <Skeleton height='24px' width='150px' /> : title }</TitleWrapper>
                <HeadlineStackContainer>
                    <HeadlineStack
                        handlers={handlers}
                        list={articleList}
                        isLoading={isLoading}
                        spotProps={{ width: 32 }}
                    />
                </HeadlineStackContainer>
            </MoreCoverageWrapper>
            : null

    );
};

MoreCoverage.propTypes = {
    articleList: PropTypes.array,
    isLoading: PropTypes.bool,
    deviceInteraction: PropTypes.object,
    language: PropTypes.string
};

export default MoreCoverage;
